module.exports = function (app) {
	'use strict';

	app.controller('pages.employee.find.review', ['$state', '$scope', '$filter', 'employee', 'storage', 'coverageBuddy','$timeout', '$rootScope', 'services',
		function ($state, $scope, $filter, employee, storage, coverageBuddy,$timeout, $rootScope , services) {

			if(window.location.href.indexOf('print=true')!= -1){
				/*$scope.printMode = true;
				$scope.find = true;*/
			}
			else{
				$scope.printMode = $state.params.print;
			}

            $scope.futureCancelledDates = [];
            $scope.futureCancelledGroups = [];
			$scope.editMode = $state.params.edit;
			setBreadcrumbs('Employee Information');




					if ($state && $state.params && $state.params.umi) {
						//to retain the state params on refresh of the page
						storage.set('thisUmi', $state.params.umi);
					} else if (storage.get("thisUmi")) {
						$state.params.umi=storage.get("thisUmi")
					}
			
			//employee.loadSummary(sessionStorage.getItem("UMI")).then(
			employee.loadSummary($state.params.umi).then(
				function(employee) {
					if (employee && employee.succeeded) {
						if ($scope.editMode) {
							if ($state.previous && $state.previous.name === 'employee.find.addCoverage') {
								$scope.employeeOrEditInProgress = employee.editInProgress;
							}
							else {
								employee.editInProgress.reset();
								$scope.employeeOrEditInProgress = employee.editInProgress.init();
							}
						}
						else {
							if (employee.editInProgress.isActive()) { employee.editInProgress.reset(); }
							employee.metadata = {}; // <-- TODO: refactor this
							$scope.employeeOrEditInProgress = employee;
						}
						if($scope.find){
							setBreadcrumbs('Employee Summary');
						}
						else{
							setBreadcrumbs(getHeading($scope.editMode));
						}
					}
					$scope.employee = employee;

					var p = coverageBuddy.getActiveGroupNumbers(employee.data.subscriber);
                    getWarningMessage(p);
                    $timeout(function () {
						if($scope.futureCancelledDates.length > 0 && $state.params.edit){
                        	if($scope.futureCancelledDates.length === 1){
                                coverageBuddy.showCoverageModal('cancelationNotice1', $rootScope.$new(), { cancelDate: $scope.futureCancelledDates , groupNumber : $scope.futureCancelledGroups  });
							}
                            else if($scope.futureCancelledDates.length === 2) {
                                coverageBuddy.showCoverageModal('cancelationNotice2', $rootScope.$new(), { cancelDate: $scope.futureCancelledDates , groupNumber : $scope.futureCancelledGroups });

                            }
                            else {
                                coverageBuddy.showCoverageModal('cancelationNotice', $rootScope.$new(), { cancelDate: $scope.futureCancelledDates , groupNumber : $scope.futureCancelledGroups });

                            }

						}
                    });



				}
			);

			$scope.$on('switchToEditMode', function() {
				employee.editInProgress.reset();
				$scope.employeeOrEditInProgress = employee.editInProgress.init();
				$scope.editMode = true;
				$state.params.edit = true;
				setBreadcrumbs(getHeading($scope.editMode));
                if($scope.futureCancelledDates.length > 0 && $scope.editMode){
                    if($scope.futureCancelledDates.length === 1){
                        coverageBuddy.showCoverageModal('cancelationNotice1', $rootScope.$new(), { cancelDate: $scope.futureCancelledDates , groupNumber : $scope.futureCancelledGroups  });
                    }
                    else if($scope.futureCancelledDates.length === 2) {
                        coverageBuddy.showCoverageModal('cancelationNotice2', $rootScope.$new(), { cancelDate: $scope.futureCancelledDates , groupNumber : $scope.futureCancelledGroups });

                    }
                else {
                        coverageBuddy.showCoverageModal('cancelationNotice', $rootScope.$new(), { cancelDate: $scope.futureCancelledDates , groupNumber : $scope.futureCancelledGroups });

                    }

                }
			});

			$scope.$on('switchToPrintMode', function() {
				$scope.printMode = true;
				if(window.location.href.indexOf('print=true')!= -1){
					$scope.find = true;
				}
				setBreadcrumbs('Employee Summary');
			});

			$scope.$watch('printMode', function (newVal) {
				if (newVal) {
					if($scope.find) {
						$timeout(function () {
							printSummary();
						});
					}
					else {
                        $timeout(function () {
                            printSummary();
                        });
					}
				}
			});

			function printSummary() {
				window.print();
				if($scope.find) {
					window.close();
				}
				$scope.printMode = false;
				setBreadcrumbs(getHeading($scope.editMode));
			}

			function setBreadcrumbs(heading) {
				if($scope.find) {
					var crumbs = {
						employeeInformation: {
							title: heading,
							state: 'employee.find.review'
						},
						findEmployee: {
							title: heading,
							state: 'employee.find'
						}
					};
				}
				else{
					var crumbs = {
						employeeInformation: {
							title: heading,
							state: 'employee.find.review'
						},
						findEmployee: {
							title: 'Find Employee',
							state: 'employee.find'
						}
					};
				}

				$scope.sidebar = { breadCrumb: { primary: crumbs.employeeInformation } };

				if ($state.previous && $state.previous.name === 'employee.find') {
					$scope.sidebar.breadCrumb.primary = crumbs.findEmployee;
					$scope.sidebar.breadCrumb.secondary = crumbs.employeeInformation;
				}
			}
			function getHeading(editMode) {
				var preHeading = editMode ? 'Edit ' : '';
				var status = coverageBuddy.hasActiveGroups(employee.data.subscriber) ? 'Active' : 'Canceled';
				return preHeading + employee.getDisplayName(employee.data.subscriber) + ': ' + status;
			}
            function truncateToDay(date) {
                date.setHours(0);
                date.setMinutes(0);
                date.setSeconds(0);
                date.setMilliseconds(0);
                return date;
            }


            function getWarningMessage(p){
                $scope.futureCancelledDates = [];
                $scope.futureCancelledGroups = [];
                p.forEach(function(active) {
                    var p1 = services.eprsvc.additionalGroupInformation().getEffectiveDate(active);
                    services.eprsvc.additionalGroupInformation({ groupNumber: active }).fetch(p1).then(
                        function(response) {
                            if(response && response.data && response.data.payload && response.data.payload.cancelDate){
                                var cancelDt = new Date(response.data.payload.cancelDate);

                                var today = new Date();
                                if(truncateToDay(cancelDt) >= truncateToDay(today)){
                                    $scope.futureCancelledDates.push(response.data.payload.cancelDate);
                                    $scope.futureCancelledGroups.push(active);

                                }
                            }
						});
				});

			}
		}
	]);
};
